import * as React from 'react';
const SvgArrowBounceRight = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path fill="#fff" fillOpacity={0.01} d="M0 0h24v24H0z" />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M19.9 6.55c-.05-.09-.1-.17-.17-.24-.08-.08-.17-.15-.27-.2C19.25 6 18.21 6 17.21 6h-2.4c-.28 0-.42 0-.53.05-.09.05-.17.12-.22.22-.05.11-.05.25-.05.53v.669c0 .11.02.19.05.249.05.09.12.17.22.22.11.05.25.05.53.05h1.79l-6.59 6.582-4.44-4.425c-.2-.2-.51-.2-.71 0l-.71.71c-.2.2-.2.509 0 .709l5.15 5.144c.39.39 1.02.39 1.41 0L18 9.426v1.788c0 .28 0 .42.05.53.05.09.12.17.22.22.11.05.25.05.53.05h.4c.19 0 .31 0 .41-.02.05 0 .08-.02.12-.04.09-.05.17-.12.22-.22.05-.11.05-.25.05-.53V8.807c0-1 0-2.038-.11-2.248z"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgArrowBounceRight;
